import Fan2Pin from '@images/fan/fan2pin.svg';
import Fan3Pin from '@images/fan/fan3pin.svg';
import Fan4Pin from '@images/fan/fan4pin.svg';
import * as React from 'react';
export default {
  Fan2Pin,
  Fan3Pin,
  Fan4Pin,
  React
};